import React from 'react';
import './DocumentTypeSelector.scss';
import { DOCUMENT_TYPES, ICONS } from 'src/common/constants';
import Col from 'src/components/Col';
import Row from 'src/components/Row';
import FontAwesomeIcon from 'src/components/Icon';
import Tile from 'src/components/Tile';

interface Props {
  selectedType: string | undefined;
  onSelectType: (type: string) => void;
}

const DocumentTypeSelector: React.FC<Props> = ({ selectedType, onSelectType }) => {
  const hasSelectedType: boolean = !!selectedType;
  const warningClassName: string = hasSelectedType
    ? 'offline-doc-form-type-warning offline-doc-form-type-warning--hidden'
    : 'offline-doc-form-type-warning';

  return (
  <div className="offline-doc-form-left">
    <div className={warningClassName} aria-hidden={hasSelectedType}>
      <FontAwesomeIcon glyph="exclamation-circle" weight="light" size="small" />
      <span>Please select a document type to continue</span>
    </div>
    <div className="offline-doc-form-section-heading">Document Type</div>
    <Row granola>
      {(DOCUMENT_TYPES as string[]).map((type: string, i: number) => (
        <Col granola key={i} md="4" xs="6">
          <Tile
            icon={
              <FontAwesomeIcon
                weight="light"
                glyph={(ICONS as any)[type === 'General' ? 'OtherDoc' : type]}
              />
            }
            onClick={() => onSelectType(type)}
            active={type === selectedType}
            title={type}
            size="small"
          />
        </Col>
      ))}
    </Row>
  </div>
  );
};

export default DocumentTypeSelector;
